<button odxButton odxMenuItem (click)="importCloudProject()" [disabled]="!navigator.onLine">
  <odx-icon name="cloud" alignLeft size="medium"></odx-icon>
  <span i18n="@@projectImport.header">Projekt importieren</span>
</button>
